import axios from "axios"
import { API_AUTH } from "../core/constants"
import { Privilege } from "../core/constants/privilege";

const API_URL = process.env.REACT_APP_API_BASEURL

let items: any = [
  { id: "1", text: "Entity Search", icon: "search", href: "./search", visible: true },
  { id: "2", text: "Access Management", icon: "user", href: "./access-management", visible: true }
]

const login = (payload: any) => {
  return axios.post(`${API_URL}${API_AUTH.LOGIN}`, payload).then(res => {
    if (res.data && res.data.token) {
      localStorage.setItem("user", JSON.stringify(res.data))
      localStorage.setItem("isAuthenticated", JSON.stringify(true))
      localStorage.setItem("username", JSON.stringify(res.data.username ? res.data.username : null));
      localStorage.setItem("privileges", JSON.stringify(res.data.privileges ? res.data.privileges : []));
    }
    return res.data
  })
}

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("username");
  localStorage.removeItem("privileges");
  localStorage.setItem("isAuthenticated", JSON.stringify(false));
}

const getCurrentUser = () => localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")!) : null;

const getUserame = () => JSON.parse(localStorage.getItem("username")!);

const isAuthenticated = () => JSON.parse(localStorage.getItem("isAuthenticated")!);

const privileges = () => JSON.parse(localStorage.getItem("privileges")!);

const hasPrivilege = (privilege: string) => {
  return privileges() ? privileges().includes(privilege) : false;
}

const privilegeItems = () => {
  items.find((i: any) => i.id === '1').visible = Auth.hasPrivilege(Privilege[Privilege.SEARCH_ENTITY]);
  items.find((i: any) => i.id === '2').visible = Auth.hasPrivilege(Privilege[Privilege.USER_MANAGEMENT]);
  const filteredItems = items?.map((item: any) => ({
    ...item,
    children: item.children ? item?.children.filter((child: any) => child.visible) : []
  })).filter((item: any) => item.visible);
  const itms = JSON.parse(JSON.stringify(filteredItems));
  if (itms.length > 0)
    return itms;
  else {
    return [{ id: "0", text: "", icon: "", href: "./not-authorized", visible: true }];
  }
}

export const Auth = {
  login,
  logout,
  getCurrentUser,
  getUserame,
  isAuthenticated,
  privileges,
  hasPrivilege,
  privilegeItems
}
